import React from "react";
import { CreateButton, FilterComponent } from '@comps/components';
import { checkPermission } from "@comps/commonFunctions";
import "./layouts-styles.css";

/**
 * The card every page's content sits in.
 *
 * The toolbar — filters, search, Create — rides above the card rather
 * than inside it: those controls act on the card's contents, so putting
 * them on the page ground keeps the card itself to just the data, and
 * the Create button no longer looks like a row of the table.
 *
 * Props:
 *   filterConfig  basic + advanced filters (unchanged shape)
 *   onCreate      shows the permission-gated Create button
 *   toolbar       extra controls for the left of the toolbar band
 *   extra         extra controls for the right (search, view toggles)
 *   flush         content sits edge-to-edge — use for tables
 *   narrow        caps the card width — use for forms, which read badly
 *                 when their fields stretch across a wide monitor
 */
const BaseBody = (props) => {
  const { filterConfig, onCreate, toolbar, extra, flush, narrow, children, module, ...rest } = props;

  const canCreate = onCreate && checkPermission(module + "_create");
  const hasAdvanced = filterConfig && filterConfig.availableFilters.length > 4;
  const hasToolbar = filterConfig || toolbar || extra || canCreate || hasAdvanced;

  return (
    <div className="site-page-wrapper" { ...rest }>
      { hasToolbar &&
        <div className="panel-toolbar">
          <div className="panel-toolbar-lead">
            { filterConfig &&
              <FilterComponent
                mode="basic"
                filters={ filterConfig.availableFilters }
                filterData={ filterConfig.filters }
                onFilter={ filterConfig.setFilters }
                api={ filterConfig.getFilters }
              /> }
            { toolbar }
          </div>

          <div className="panel-toolbar-trail">
            { extra }
            { hasAdvanced &&
              <FilterComponent
                mode="advance"
                filters={ filterConfig.availableFilters }
                filterData={ filterConfig.filters }
                onFilter={ filterConfig.setFilters }
                api={ filterConfig.getFilters }
              /> }
            { canCreate && <CreateButton onClick={ onCreate } /> }
          </div>
        </div> }

      <div className={ `panel ${narrow ? 'is-narrow' : ''}` }>
        <div className={ `panel-content ${flush ? 'is-flush' : ''}` }>
          { children }
        </div>
      </div>
    </div>
  );
};

export default BaseBody;
